<template>
  <div id="app" class="app">
    <AppHeader id="app-header" />
    <div id="app-body" class="app-body">
      <main class="main">
        <div  id="app-content"
              class="container-fluid"
              v-bind:class="{ 'container-fluid-fix': fixContainerFluidPadding }" >
          <!-- Cache check & surveyrevision explorer when opening survey revisions -->
          <keep-alive include="CheckExplorer"
                      v-if="$route.name === 'CheckExplorer' || $route.name === 'SurveyRevisionExplorer' || $route.name === 'SurveyImprovementExplorer' || $route.name === 'SurveyRevision' || $route.name === 'SurveyImprovement'">
            <!-- Ensure that call to $router.replace in SurveyRevision.vue / SurveyImprovement.vue uses the same component when creating a new check revision / check improvement -->
            <router-view :key="($route.name === 'SurveyRevision' || $route.name === 'SurveyImprovement') && $route.params ? $route.path.replace(new RegExp('/' + $route.params.id), '') : $route.path"></router-view>
          </keep-alive>
          <router-view v-else></router-view>
        </div>
      </main>
    </div>
    <AppFooter id="app-footer" />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter-APP_TARGET'

export default {
  name: 'Full',
  components: { AppHeader, AppFooter },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },
    fixContainerFluidPadding () {
      if (APP_TARGET === "bmw")
        return this.$route.name == 'CX';
      else
        return false;
    }
  }
}
</script>

<style scoped>
.container-fluid-fix {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
